import * as types from "../actions/types/index";

const INITIAL_STATE = {
    isVisible:true
};
export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.HIDE_LEFT_BAR:
            return {
                ...state,
                isVisible: action.isVisible
            };
        case types.SHOW_LEFT_BAR:
            return {
                ...state,
                isVisible: action.isVisible
            };
        default:
            return {
                ...state
            }
    }
}